
import React, {useState} from 'react';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../Auth";
import LoginPage from "./Login";

import AppLayout from '@cloudscape-design/components/app-layout';
import AppLayoutToolbar from '@cloudscape-design/components/app-layout-toolbar';
import { I18nProvider } from '@cloudscape-design/components/i18n';
import enMessages from '@cloudscape-design/components/i18n/messages/all.en.json';
import SideNavigation from '@cloudscape-design/components/side-navigation';
import { BreadcrumbGroup } from '@cloudscape-design/components';





export default function MainPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [navigationOpen, setNavigationOpen] = useState(false); 

  function handleNavFollow(event) {
    event.preventDefault(); // Prevent default link behavior
    setNavigationOpen(false); 
    navigate(event.detail.href); // Update state to show the selected page
  }

  const navHeader = { text: 'WDE', href: '' };

  var navItems = [
    { type: 'link', text: 'Playtest', href: 'Playtest' },
    { type: 'link', text: 'Development', href: 'Development' },
    { type: 'link', text: 'Demo', href: 'Demo' },
    { type: 'link', text: 'Stake Account', href: 'StakeAccount' },
    { type: 'link', text: 'Focus Group Spike', href: 'FocusGroupSpike' },
    { type: 'link', text: 'OAuth Account', href: 'Account' },

  ];
  //if(auth.admin){
    navItems.push({ type: 'link', text: 'Test Build', href: 'Test' })
  //}


  var breadcrumbItems = [
    { type: 'link', text: 'WDE', href: '' },
  ];
  const segments = location.pathname.split("/").filter(Boolean);
  segments.forEach((segment)=>{ breadcrumbItems.push({ type: 'link', text: segment, href: segment }) })

  return (
    <I18nProvider locale="en" messages={[enMessages]}>
      {!auth.userData ? (
        <LoginPage/>
      ) : (
        <AppLayout
          navigationOpen={navigationOpen}
          onNavigationChange={() => setNavigationOpen(!navigationOpen)}  // <-- Toggle on hamburger
          content={
            <Outlet/>
          }
          contentType="default"
          toolsHide={true}
          tools={
            <AppLayoutToolbar
              breadcrumbs={
                <BreadcrumbGroup items={breadcrumbItems} ariaLabel="Breadcrumbs" onFollow={handleNavFollow}/>
              }
            />
          }
          navigation={
            <SideNavigation
              header={navHeader}
              items={navItems}
              onFollow={handleNavFollow}
            />
          }
        />
      )}
    </I18nProvider>
  );

}
